import React, { useContext, useLayoutEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";


import Home from "./Home/Home";
import Movie from "./Pages/Movie_detail";
import Game from "./Pages/Game_detail";
import MovieList from './List/Movie';
import GameList from './List/Game';
import MovieEditor from './Editor/Movie'
import GameEditor from './Editor/Game';

import CreateMovie from './crud/CreateMovie';
import MovieEdit from './crud/EditMovie'
import GameEdit from './crud/EditGame';

import { BaseContext } from './BaseContext'
import CreateGame from "./crud/CreateGame";



const Routes = () => {

  const { token } = useContext(BaseContext);

  // Scroll to top if path changes
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Switch>
      <Route exact path="/">
        <Home />
      </Route>

      <Route exact path="/movie_list">
        <MovieList />
      </Route>
      <Route exact path="/game_list">
        <GameList />
      </Route>

      {token == "" ? <>
        <Route exact path="/movie/create">
          <Redirect to="/" />
        </Route>
        <Route exact path="/game/create">
          <Redirect to="/" />
        </Route>
        <Route exact path="/movie/edit/:id" children={<Redirect to="/" />} />
        <Route exact path="/game/edit/:id" children={<Redirect to="/" />} />
        <Route exact path="/movie/:id">
          <Movie />
        </Route>
        <Route exact path="/game/:id">
          <Game />
        </Route>
        <Route exact path="/movie_editor">
          <Redirect to="/" />
        </Route>
        <Route exact path="/game_editor">
          <Redirect to="/" />
        </Route>
      </>
        : <>
          <Route exact path="/movie/create">
            <CreateMovie />
          </Route>
          <Route exact path="/game/create">
            <CreateGame />
          </Route>
          <Route exact path="/movie/edit/:id">
            <MovieEdit />
          </Route>
          <Route exact path="/game/edit/:id">
            <GameEdit />
          </Route>
          <Route exact path="/movie/:id">
            <Movie />
          </Route>
          <Route exact path="/game/:id">
            <Game />
          </Route>
          <Route exact path="/game_editor">
            <GameEditor />
          </Route>
          <Route exact path="/movie_editor">
            <MovieEditor />
          </Route>

        </>
      }


    </Switch>
  );
};

export default Routes;
